// Card types supported by the system
export const CARD_TYPES = [
    { id: 'MASTERCARD', name: 'Mastercard' },
    { id: 'DINERS', name: 'Diners' },
    { id: 'VISA', name: 'Visa' },
    { id: 'DISCOVER', name: 'Discover' },
    { id: 'AMEX', name: 'American Express' },
    { id: 'JCB', name: 'JCB' }
];